<div class="info-card mb-4">
  <div class="card-header">
    <span class="card-title mb-0"> Policy Statistics </span>
  </div>

  <div class="card-info row">
    <div class="col-sm-4 col-12">
      <div class="card-info-label">Total Policy Amount</div>
      <div class="card-info-value">{{ contractAmount | currency }}</div>
    </div>

    <div class="col-sm-4 col-12">
      <div class="card-info-label">Total Premium</div>
      <div class="card-info-value">{{ totalPremium | currency }}</div>
    </div>

    <div class="col-sm-4 col-12">
      <div class="card-info-label">Number of Policies</div>
      <div class="card-info-value">{{ contractCount | number }}</div>
    </div>

    <ngx-loading
      [show]="loading"
      [config]="{
        fullScreenBackdrop: false,
      }"
    ></ngx-loading>
  </div>
</div>
